<h6 mat-dialog-title class="text-primary heading">{{ dialogHeading }}</h6>
<div mat-dialog-content>
  <div class="row">
    <div class="col-12">
      <table class="table">
        <thead>
          <tr>
            @for (item of headerColumns; track item) {
              <th class="bg-table-head" scope="col">{{ item }}</th>
            }
          </tr>
        </thead>
        <tbody class="table-group-divider">
          @for (item of responseMessageList; track item) {
            <tr>
              @for (key of rowKeys; track key) {
                <th>{{ item[key] || "-" }}</th>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button class="btn-md-outlined-error" tabindex="-1" matRipple [mat-dialog-close]="true">Close</button>
</div>
